import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  let verificandoVersao = false;

  const avisarNovaVersao = () => {
    if (document.getElementById("aviso-nova-versao")) return;
    const aviso = document.createElement("div");
    aviso.id = "aviso-nova-versao";
    aviso.setAttribute("role", "status");
    aviso.style.cssText = "position:fixed;bottom:16px;left:16px;right:16px;z-index:10000;max-width:520px;margin:auto;padding:14px 16px;border-radius:12px;background:#123963;color:#fff;box-shadow:0 12px 32px #0004;display:flex;align-items:center;justify-content:space-between;gap:12px;font:600 14px sans-serif";
    const mensagem = document.createElement("span");
    mensagem.textContent = "Nova versão disponível. Atualize para ver o painel mais recente.";
    const botao = document.createElement("button");
    botao.type = "button";
    botao.textContent = "Atualizar";
    botao.style.cssText = "border:0;border-radius:8px;background:#fff;color:#123963;padding:9px 12px;font-weight:700;cursor:pointer";
    botao.addEventListener("click", () => window.location.reload());
    aviso.append(mensagem, botao);
    document.body.appendChild(aviso);
  };

  const verificarVersao = async () => {
    if (verificandoVersao || !navigator.onLine) return;
    verificandoVersao = true;
    try {
      const resposta = await fetch(`/asset-manifest.json?v=${Date.now()}`, { cache: "no-store" });
      if (!resposta.ok) return;
      const manifest = await resposta.json();
      const arquivoPrincipal = String(manifest.files?.["main.js"] || "");
      const versao = arquivoPrincipal.match(/main\.([^.]+)\.js/)?.[1];
      if (!versao) return;
      const scriptAtual = document.querySelector('script[src*="/static/js/main."]')?.getAttribute("src") || "";
      const versaoAtual = scriptAtual.match(/main\.([^.]+)\.js/)?.[1];
      if (versaoAtual && versaoAtual !== versao) avisarNovaVersao();
      await navigator.serviceWorker.register(`/service-worker.js?build=${encodeURIComponent(versao)}`, { updateViaCache: "none" });
    } catch (error) {
      console.warn("Nao foi possivel conferir a versao offline do aplicativo.", error);
    } finally {
      verificandoVersao = false;
    }
  };

  window.addEventListener("load", () => {
    verificarVersao();
  });
  window.addEventListener("online", verificarVersao);
  window.addEventListener("focus", verificarVersao);
  window.setInterval(verificarVersao, 60 * 1000);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) verificarVersao();
  });
}
